import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../../store/selectors/app.selector";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
import AccountCard from "../../components/account-card";
import AccountSelectedCard from "../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import OTP from "../../components/otp";
import BeneficiaryDisplay from "../../components/beneficiary-display";
import { CONFIG } from "../../environment";
import TransferService from "../../services/transfer.service";
import { NumericFormat } from "react-number-format";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyNumbers,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  amountExchangeCurrencyFormat,
  amountFormat,
} from "../../services/common.service";
import dayjs from "dayjs";
import AccountService from "../../services/accounts.service";
import {
  setAccountList,
  setSelectedAccount,
} from "../../store/actions/app.action";
import AccountDisplayView from "../../components/account-display-view";
import AccountDisplay from "../../components/account-display";
import { VscError } from "react-icons/vsc";
import SendMoneyService from "../../services/send-money.service";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default function RepaymentTransfer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [stage, setStage] = useState(1);
  const accountList = useSelector(accountListSelector);
  const location = useLocation();
  const [form] = Form.useForm();
  const [cancelVisible, setCancelVisible] = useState(false);
  const [respDetails, setRespDetails] = useState({});
  const selectedAccount = useSelector(selectedAccountSelector);
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [payeeDetails, setPayeeDetails] = useState({});
  const [convertedAmount, setConvertedAmount] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [hasFxDeal, setHasFxDeal] = useState(false);
  const [txnCurrencyList, setTxnCurrencyList] = useState([]);
  const [selectedTxnCcy, setSelectedTxnCcy] = useState();
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [chargesList, setChargesList] = useState([]);
  const [metaData, setMetaData] = useState({
    frequency: [],
    maximumInstallments: [],
    paymentTypes: {},
    transferTypes: {},
    tipsMaxAmount: 1,
  });
  const [paymentType, setPaymentType] = useState("ONCE");
  const [paymentSubType, setPaymentSubType] = useState("Pay_Now");

  useEffect(() => {
    transferOptions();
    if (location.state) {
      setPayeeDetails(location.state);
      const selectedAccDetail = accountList.find(
        (e) => e.accountNo === location.state.srcAccount
      );
      dispatch(setSelectedAccount(selectedAccDetail));
      // getTxnCurrency();
      const today = dayjs();
      const scheduledDate = dayjs(location.state?.scheduledDate).utc(true);
      const frequencyDate = scheduledDate.isBefore(today, "day")
        ? today
        : scheduledDate;
      form.setFieldsValue({
        transferType: location.state.transferType,
        hasFxDeal: location.state.fxDealNo !== null ? true : false,
        amount: location.state.amount,
        // txnCcy: location.state.txnCcy,
        remarksTag: location.state.remarksTag,
        frequencyDate: frequencyDate,
        numberOfInstallments: location.state?.numberOfInstallments || "",
        frequency: location.state?.frequency || "",
        paymentType:
          location.state.paymentType === "RECURRING" ? "RECURRING" : "ONCE",
        paymentSubType:
          location.state.paymentType === "SCHEDULED" ? "Pay_Later" : "Pay_Now",
      });
      setPaymentType(
        location.state.paymentType === "RECURRING" ? "RECURRING" : "ONCE"
      );
      setPaymentSubType(
        location.state.paymentType === "SCHEDULED" ? "Pay_Later" : "Pay_Now"
      );
      // if (location.state.txnCcy !== location.state.srcCcy) {
      //   getConvertedAmount();
      // }
    }
  }, []);
  useEffect(() => {
    if (location.state) {
      setConvertedAmount({});
      if (location.state.amount === undefined) {
        form.resetFields(["amount"]);
      }
      if (CONFIG?.CROSS_CURRENCY === false) {
        setTxnCurrencyList([selectedAccount?.accountCurrency]);
      } else if (
        payeeDetails?.destCcy === selectedAccount?.accountCurrency
      ) {
        setTxnCurrencyList([selectedAccount?.accountCurrency]);
      } else {
        setTxnCurrencyList([
          payeeDetails?.destCcy,
          selectedAccount?.accountCurrency,
        ]);
      }
      form.setFieldsValue({ txnCcy: selectedAccount?.accountCurrency });
    }
  }, [selectedAccount, payeeDetails]);

   const transferOptions = useCallback(async () => {
      try {
        const response = await SendMoneyService.transferOptions();
        if (response.status === 200) {
          setMetaData(response.data["data"]);
        }
      } catch (error) {}
    }, []);

  const getTxnCurrency = useCallback(async () => {
    try {
      const transferType = payeeDetails.transferType;
      const reqParams = {
        transferType: transferType,
      };
      const response = await TransferService.getTxnCurrency(reqParams);
      if (response.status === 200) {
        const currencies = response.data["data"].map((ele) => ele.currencyCode);
        setTxnCurrencyList(currencies);
      }
    } catch (error) {}
  }, [payeeDetails]);

  const getConvertedAmount = useCallback(async () => {
    try {
      if (CONFIG?.CROSS_CURRENCY === false) {
        return;
      }
      const { amount, txnCcy, fxDealRefNo } = form.getFieldsValue();
      setSelectedTxnCcy(txnCcy);
      const transferAmount =
        typeof amount === "number"
          ? amount
          : parseFloat(amount.replaceAll(/,/g, ""));

      const reqParams = {
        srcCcy: selectedAccount?.accountCurrency,
        destCcy: txnCcy,
        txnCcy: txnCcy,
        txnType: payeeDetails?.transferType,
        amount: transferAmount,
        fxDealRefNo: fxDealRefNo,
        srcAcct: selectedAccount?.accountNo,
        accountName: selectedAccount?.accountName,
        srcAccName: selectedAccount?.accountName,
      };
      if (txnCcy === selectedAccount?.accountCurrency) {
        return;
      }
      const response = await TransferService.getConvertedAmount(reqParams);
      if (response.status === 200) {
        setConvertedAmount(response.data["data"]);
      }
    } catch (error) {}
  }, [selectedAccount, payeeDetails]);

  const getSrcAccDetails = useCallback(() => {
    return accountList.find(
      (ele) => ele.accountNo === selectedAccount.accountNo
    );
  }, [accountList, selectedAccount]);

  const getTransferAmount = (amount) => {
    return typeof amount === "number"
      ? amount
      : parseFloat(amount.replaceAll(/,/g, ""));
  };

  const buildReqParams = useCallback(
    (values) => {
      const srcAccDetails = getSrcAccDetails();
      const transferAmount = getTransferAmount(values.amount);
      if (CONFIG?.CROSS_CURRENCY === false) {
        if (srcAccDetails?.accountCurrency !== payeeDetails?.destCcy) {
          setIsErrorVisible(true);
          return;
        }
      }
      return {
        txnId: payeeDetails?.txnId,
        srcAcct: srcAccDetails?.accountNo,
        accountName: srcAccDetails?.accountName,
        srcAccName: srcAccDetails?.accountName,
        srcBr: srcAccDetails?.branchId,
        srcCcy: srcAccDetails?.accountCurrency,
        destBr: payeeDetails?.destAccBranch,
        destCcy: values.txnCcy,
        destAcct: payeeDetails?.destAccount,
        amount: transferAmount,
        narration: values?.remarksTag || "",
        remarks: values?.remarksTag || "",
        remarksTag: values?.remarksTag,
        txnType: payeeDetails?.transferType,
        quickTransfer: false,
        destBankName: payeeDetails?.destBankName,
        destBankAddr: "",
        destBankCty: "",
        txnCcy: values?.txnCcy,
        txnDate: dayjs(new Date()),
        chargeBornesBy: "OUR",
        beneName: payeeDetails?.destAccName || "",
        beneMobileNo: "",
        beneMail: "",
        beneAddr: "",
        fxDealRefNo: payeeDetails?.fxDealNo || values?.fxDealRefNo || "",
        bicCode: payeeDetails?.bicCode || "",
        sortCode: payeeDetails?.sortCode || "",
        swiftCode: payeeDetails?.swiftCode || "",
        custId: srcAccDetails?.customerId,
        paymentType: payeeDetails?.paymentType,
        numberOfInstallments: values?.numberOfInstallments || "",
        customFields: payeeDetails?.customFields,
        payeeId: payeeDetails?.payeeId,
        scheduled: payeeDetails?.paymentType === "ONCE" ? false : true,
        addBene: false,
        recurring: payeeDetails?.paymentType === "RECURRING" || "",
        scheduledDate: values?.frequencyDate
            ? values?.frequencyDate.format("YYYY-MM-DD")
            : "",
        frequency: values?.frequency || "",
        ...(payeeDetails.transferType === "SWIFT" && {
          addressLine1: "",
          addressLine2: "",
          city: "",
          beneCountry: "",
          bankCountry: "",
          fileNames: payeeDetails?.files || "",
        }),
      };
    },
    [payeeDetails, selectedAccount, accountList]
  );

  const onVerify = useCallback(
    async (values) => {
      try {
        const reqParams = buildReqParams(values, {});
        setFormDetails(reqParams);
        getCharges(reqParams);
        // setStage(2);
      } catch (error) {}
    },
    [accountList, payeeDetails, selectedAccount]
  );

  const repaymentTransferVerify = useCallback(async () => {
    try {
      const response = await TransferService.repaymentTransferVerify(
        formDetails
      );
      if (response.status === 200) {
        if (response.data["data"]["otpEnabled"]) {
          setStage(3);
        } else {
          repaymentTransferConfirm({
            ...formDetails,
            ...{ otp: CONFIG.DEFAULT_OTP },
          });
        }
      }
    } catch (error) {}
  }, [formDetails]);

  const repaymentTransferConfirm = useCallback(async (reqParams) => {
    try {
      const response = await TransferService.repaymentTransferConfirm(
        reqParams
      );
      if (response.status === 200) {
        dispatch(setAccountList([]));
        setRespDetails({
          message: response.data?.message,
          ...response.data["data"],
        });
        setSuccessVisible(true);
        await AccountService.getQuickAccounts("BA");
      }
    } catch (error) {
      setOtp("");
      if (["TG-USR-40025", "TG-USR-40026"].indexOf(error.data.code) < 0) {
        setStage(1);
      }
    }
  }, []);

  const getCharges = useCallback(
    async (data) => {
      try {
        const req = {
          srcAcct: data.srcAcct,
          srcCcy: data.srcCcy,
          destCcy: data.destCcy,
          txnCcy: data.txnCcy,
          amount: data.amount,
          txnType: data.txnType,
        };
        const response = await AccountService.getAllCharges(req);
        if (response.status === 200) {
          setChargesList(response.data);
          setStage(2);
        }
      } catch (error) {}
    },
    []
  );
  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <OTP
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) =>
              repaymentTransferConfirm({
                ...formDetails,
                ...values,
              })
            }
            handleResendOtp={() => repaymentTransferVerify()}
            cancelTransaction={() => {
              navigate("/history/ft");
            }}
            type="TRANSACTION"
          />
        );
      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <div className="bene-align">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <AccountDisplay type="image" />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
              <p style={{ fontSize: 10, fontWeight: 600 }}>
                {t("common.to", { defaultValue: "To" })}
              </p>
            </div>
            <div
              className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              style={{ marginTop: "-19px" }}
            >
              <BeneficiaryDisplay beneDetails={payeeDetails} />
            </div>
          </div>
        </div>
        <Form
          layout="vertical"
          form={form}
          initialValues={payeeDetails}
          onFinish={onVerify}
        >
          <div className="row">
            <div
              className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              style={{ position: "relative" }}
            >
                <Form.Item
                label={t("pages.fundtransfer.transaction_curr", {
                  defaultValue: "Transaction Currency",
                })}
                name={"txnCcy"}
                rules={[
                  {
                    required: txnCurrencyList.length <= 1 ? false : true,
                    message: t("errorMesssages.trans_currency_require", {
                      defaultValue: "Transaction Currency is required",
                    }),
                  },
                ]}
              >
                {txnCurrencyList.length <= 1 ? (
                  <Input readOnly size="large" />
                ) : (
                  <Select
                    placeholder={t("pages.fundtransfer.transaction_curr", {
                      defaultValue: "Transaction Currency",
                    })}
                    bordered={true}
                    size="large"
                    optionFilterProp="children"
                    showSearch
                    onChange={(e) => {
                      form.setFieldsValue({ amount: "" });
                      setConvertedAmount({});
                    }}
                  >
                    {txnCurrencyList.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("common.amount", {
                  defaultValue: "Amount",
                })}
                name={"amount"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.amount_required", {
                      defaultValue: "Amount is required",
                    }),
                  },
                  {
                    validator: (_, value) => {
                      if (parseFloat(value) <= 0) {
                        return Promise.reject(
                          t("errorMesssages.amount_valid", {
                            defaultValue: "Amount should be greater than 0",
                          })
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder={t("common.amount", {
                    defaultValue: "Amount",
                  })}
                  maxLength={12}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                  size="large"
                  onBlur={(e) => {
                    e.target.value.length > 0 && getConvertedAmount();
                  }}
                  onChange={() => setConvertedAmount({})}
                />
              </Form.Item>
              {Object.keys(convertedAmount).length !== 0 && (
                <div className="row mb-2">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <label className="mb-1">
                      {convertedAmount?.prefferedRate === true
                        ? t("pages.sendMoney.common_sendMoney.preffered_rate", {
                            defaultValue: "Preffered Rate",
                          })
                        : t("pages.sendMoney.common_sendMoney.exchange_rate", {
                            defaultValue: "Exchange Rate",
                          })}
                    </label>{" "}
                    <br />
                    <span>
                      1 {selectedAccount?.accountCurrency} ={" "}
                      {selectedTxnCcy + " " + convertedAmount.convRate}
                    </span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <label className="mb-1">
                      {" "}
                      {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                        defaultValue: "Deducted Amount",
                      })}
                    </label>
                    <br />
                    <span>{convertedAmount.deductedAmt}</span>
                  </div>
                </div>
              )}
            </div>
            <div>
              {/* {form?.getFieldValue("txnCcy") !==
                selectedAccount?.accountCurrency && (
                <Form.Item
                  label={""}
                  name={"hasFxDeal"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.has_fx_deal_require", {
                        defaultValue: "Has Fx Deal is required",
                      }),
                    },
                  ]}
                >
                  <span style={{ marginRight: "10px" }}>
                    <span className="asterisk-mark">*</span>
                    {t("pages.fundtransfer.hasfx", {
                      defaultValue: "Has Fx Deal ?",
                    })}
                  </span>
                  <Radio.Group
                    onChange={(e) => setHasFxDeal(e.target.value)}
                    value={hasFxDeal}
                  >
                    <Radio value={true}>
                      {t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })}
                    </Radio>
                    <Radio value={false}>
                      {t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              )} */}
              {hasFxDeal &&
                form?.getFieldValue("txnCcy") !==
                  selectedAccount?.accountCurrency && (
                  <div className="col-12">
                    <Form.Item
                      label={t("pages.fundtransfer.fxno", {
                        defaultValue: "Fx Ref Number",
                      })}
                      name={"fxDealRefNo"}
                      rules={[
                        {
                          required: true,
                          message: t("errorMesssages.fx_ref_num_require", {
                            defaultValue: "Fx Ref Number is required",
                          }),
                        },
                      ]}
                    >
                      <Input
                        onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                        maxLength={30}
                        placeholder={t("pages.fundtransfer.fxno", {
                          defaultValue: "Fx Ref Number",
                        })}
                        size="large"
                        onBlur={(e) => {
                          e.target.value.length > 0 && getConvertedAmount();
                        }}
                      />
                    </Form.Item>
                  </div>
                )}
            </div>
            <span
              className="d-block mb-3 "
              style={{ textAlign: "left", cursor: "pointer" }}
            >
              {/* {showAdvanced && (
                <>
                  <HiOutlineMinusSmall />
                  {t("pages.fundtransfer.payment_option", {
                    defaultValue: "Payment Options",
                  })}
                </>
              )} */}

              {t("pages.fundtransfer.payment_option", {
                defaultValue: "Payment Options",
              })}
            </span>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-5">
                <Form.Item
                  label=""
                  name={"paymentType"}
                  style={
                    paymentType === "RECURRING"
                      ? { marginBottom: 20 }
                      : { marginBottom: 5 }
                  }
                >
                  <Radio.Group
                    onChange={(e) => setPaymentType(e.target.value)}
                    disabled
                  >
                    <Radio value={"ONCE"}>
                      {t("pages.fundtransfer.one_time", {
                        defaultValue: "Once Off Payment",
                      })}
                    </Radio>
                    <Radio value={"RECURRING"}>
                      {t("pages.fundtransfer.recurring", {
                        defaultValue: "Recurring",
                      })}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
                {paymentType === "ONCE" && (
                  <Form.Item label="" name={"paymentSubType"}>
                    <Radio.Group
                      onChange={(e) => setPaymentSubType(e.target.value)}
                      disabled
                    >
                      <Radio value={"Pay_Now"}>
                        {t("pages.fundtransfer.pay_now", {
                          defaultValue: "Pay Now",
                        })}
                      </Radio>
                      <Radio value={"Pay_Later"}>
                        {t("pages.fundtransfer.pay_latter", {
                          defaultValue: "Pay Later",
                        })}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
              </div>
            </div>

            {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
              <div className="col-12">
                <Form.Item
                  label={t("pages.sendMoney.common_sendMoney.date", {
                    defaultValue: "Date",
                  })}
                  name={"frequencyDate"}
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.date_require", {
                        defaultValue: "Date is required",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    // inputReadOnly={true}
                    allowClear={false}
                    showToday={false}
                    disabledDate={(current) => {
                      return (
                        dayjs().add(0, "days") >= current ||
                        dayjs().add(1, "month") <= current
                      );
                    }}
                    placeholder="DD-MM-YYYY"
                    // format={"DD-MM-YYYY"}
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}

            {paymentType === "RECURRING" && (
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <Form.Item
                  label={t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                  name={"numberOfInstallments"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.no_insdtall_require", {
                        defaultValue: "Number of installment is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.fundtransfer.no_of_instal", {
                      defaultValue: "Number of installment",
                    })}
                    bordered={true}
                    size="large"
                  >
                    {metaData.maximumInstallments.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {paymentType === "RECURRING" && (
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <Form.Item
                  label={t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                  name={"frequency"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.freq_requir", {
                        defaultValue: "Frequency is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.fundtransfer.frequency", {
                      defaultValue: "Frequency",
                    })}
                    bordered={true}
                    size="large"
                  >
                    {metaData.frequency.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {paymentType === "RECURRING" && (
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <Form.Item
                  label={t("pages.common.start_date", {
                    defaultValue: "Start Date",
                  })}
                  name={"frequencyDate"}
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.start_date_require", {
                        defaultValue: "Start Date is required",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    // inputReadOnly={true}
                    allowClear={false}
                    showNow={false}
                    disabledDate={(current) => {
                      return (
                        dayjs().add(-1, "days") >= current ||
                        dayjs().add(1, "month") <= current
                      );
                    }}
                    placeholder="DD-MM-YYYY"
                    // format={"DD-MM-YYYY"}
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}
            <div className="col-12">
              <Form.Item
                name="remarksTag"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.remark_require", {
                      defaultValue: "Reason is required",
                    }),
                  },
                ]}
                label={t("common.remarks", {
                  defaultValue: "Reason",
                })}
              >
                <Input
                  placeholder={t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                  size="large"
                  onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                  maxLength={30}
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex justify-content-end  mt-3">
            <Button
              size="large"
              onClick={() => navigate("/history/ft")}
              type="default"
              style={{ marginRight: 20 }}
              className="secondary-btn"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="primary-btn"
            >
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        {" "}
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>
        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>
        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <AccountDisplayView />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
              <p style={{ fontSize: 10, fontWeight: 600 }}>
                {t("common.to", { defaultValue: "To" })}
              </p>
            </div>
            <div
              className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              style={{ marginTop: "-8px" }}
            >
              <BeneficiaryDisplay beneDetails={payeeDetails} />
            </div>
          </div>
        </div>
        <div className="mt-3 confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.fundtransfer.transaction_curr", {
                  defaultValue: "Transaction Currency",
                })}
              </label>
              <span>{formDetails?.txnCcy}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>
                {amountFormat(formDetails?.amount, formDetails?.txnCcy)}
              </span>
            </div>
            {Object.keys(convertedAmount).length !== 0 && (
              <div className="confirm-label-wrapper">
                <label className="mb-1">
                  {" "}
                  {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                    defaultValue: "Deducted Amount",
                  })}
                </label>
                <span>{convertedAmount.deductedAmt}</span>
              </div>
            )}
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>
                {formDetails?.txnType === "IAT"
                  ? t("pages.fundtransfer.internal_account_transfer", {
                      defaultValue: "Internal Account Transfer",
                    })
                  : formDetails?.txnType}
              </span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.view_scheduled_transfer.payment_type", {
                  defaultValue: "Payment Type",
                })}
              </label>
              <span>
                {metaData.paymentTypes[formDetails?.paymentType] ||
                  formDetails?.paymentType}
              </span>
            </div>

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                </label>
                <span>{formDetails?.numberOfInstallments || "-"}</span>
              </div>
            ) : null}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                </label>
                <span>{formDetails?.frequency}</span>
              </div>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.common_sendMoney.date", {
                  defaultValue: "Date",
                })}
              </label>
              {paymentType === "ONCE" && paymentSubType === "Pay_Now" && (
                <span>{dayjs().format("DD-MM-YYYY")}</span>
              )}
              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}

              {paymentType === "RECURRING" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}
            </div>
            {hasFxDeal ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                  </label>
                  <span>{formDetails?.fxDealRefNo}</span>
                </div>
              </>
            ) : null}
             <div className="confirm-label-wrapper">
              <label>
                {t("pages.service_request.common_service.charges", {
                  defaultValue: "Charges",
                })}
              </label>
              <span>{amountFormat(chargesList.charges, formDetails?.txnCcy)}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("common.remarks", {
                  defaultValue: "Reason",
                })}
              </label>
              <span>{formDetails?.remarksTag || "-"}</span>
            </div>
            <div className="d-flex justify-content-end mt-5 ">
              {/* <Button
                onClick={() => setCancelVisible(true)}
                type="default"
                style={{ marginRight: 30 }}
                className="secondary-btn"
                size="large"
              >
                {t("buttons.cancel_btn", {
                  defaultValue: "Cancel",
                })}
              </Button> */}

              <Button
                onClick={() => {
                  setStage(1);
                }}
                type="default"
                className="secondary-btn mx-3"
                size="large"
              >
                {t("buttons.back_btn", {
                  defaultValue: "Back",
                })}
              </Button>
              <Button
                onClick={() => repaymentTransferVerify()}
                type="primary"
                className="primary-btn"
                size="large"
              >
                {t("buttons.proceed_btn", {
                  defaultValue: "Proceed",
                })}
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history")}>
              {" "}
              {t("navigation.history", {
                defaultValue: "History",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history/ft")}>
              {" "}
              {t("pages.fundtransfer.fund_transfer", {
                defaultValue: "Fund Transfer",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.repayment", {
                defaultValue: "Re-payment",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.repayment", {
                defaultValue: "Re-payment",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountCard />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountSelectedCard />
            </Card>
          </div>
        )}

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="payee-render-section application-card">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={t("pages.sendMoney.payee.quick_transfer", {
          defaultValue: "Cancel transfer?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitCancelTitle", {
            defaultValue:
              " If you cancel this transaction now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            type="default"
            className="secondary-btn"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/history/ft");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>
      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{respDetails.message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/dashboard");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={isErrorVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <VscError
            style={{ display: "block", margin: "10px 0" }}
            size={50}
            fill="#ff4d4f"
          />
          <h5 className="mb-3" style={{ color: "#ff4d4f" }}>
            Alert!
          </h5>
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            Cross currency transactions are not allowed at this time.
          </p>
          <div align="center">
            <Button
              onClick={() => {
                setIsErrorVisible(false);
              }}
              type="primary"
              size="large"
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
